import { findCountryById } from "./countrystateutils";

export const countrySupportsPeppol = (value: server.dto.Countries) => {
  const country = findCountryById(value);
  return country.isEuMember;
}